import type { ReviewPage } from '@shared/types';

interface Props {
  page: ReviewPage;
  cacheBust: string;  // e.g., head sha
  onIframeReady?: (win: Window | null) => void;
}

export function PreviewFrame({ page, cacheBust, onIframeReady }: Props) {
  if (page.kind === 'removed' || !page.url) {
    return (
      <div className="flex-1 flex items-center justify-center text-muted-foreground p-8">
        This page was removed in this PR.
        {page.oldUrlPath && (
          <code className="ml-2 text-xs">({page.oldUrlPath})</code>
        )}
      </div>
    );
  }
  const articleBase = import.meta.env.VITE_ARTICLE_BASE as string | undefined;
  const articleUrl = articleBase
    ? page.url.replace(/^https?:\/\/[^/]+/, articleBase)
    : page.url;
  const sep = articleUrl.includes('?') ? '&' : '?';
  const src = `${articleUrl}${sep}_pr=${encodeURIComponent(cacheBust)}&dashboard=1`;
  return (
    <iframe
      src={src}
      title={page.title}
      sandbox="allow-scripts allow-same-origin allow-forms"
      className="flex-1 w-full border-0 bg-white"
      onLoad={(e) => {
        const el = e.target as HTMLIFrameElement;
        onIframeReady?.(el.contentWindow);
      }}
    />
  );
}
